module.exports = __webpack_public_path__ + "static/ConcreteSectionGeometry-e8e4a2ba21151ac447469bd41567a5ef.jpg";